import get from 'lodash/get';
import { http } from '@pendo/http';
import { isDisplayableValue } from '@utils/metadata';
const visitorApi = '/api/s/_SID_/visitor';

function resolveVisitorId (visitor) {
    return get(visitor, 'metadata.auto.id', '') || visitor?.id || '';
}

export function searchVisitors (searchTerm = '') {
    const params = `?search=${encodeURIComponent(searchTerm)}`;

    return http.get(`${visitorApi}${params}`);
}

export function getVisitorDisplayName ({ visitor, visitorId, setting }) {
    const path = setting?.value;
    if (!path) return undefined;

    let mapped = get(visitor, `metadata.${path}`);
    if (!isDisplayableValue(mapped) && path !== path.toLowerCase()) {
        mapped = get(visitor, `metadata.${path.toLowerCase()}`);
    }
    if (isDisplayableValue(mapped)) return mapped;

    return visitorId || resolveVisitorId(visitor);
}

export function getDynamicVisitorKey (visitorDisplayNamePath) {
    if (!visitorDisplayNamePath || typeof visitorDisplayNamePath !== 'string') return null;

    const parts = visitorDisplayNamePath.split('.');
    if (parts.length !== 2) return null;

    return `visitor_${parts[0]}_${parts[1]}`;
}
